import { ServiceItemProps } from "apis";
import { lazy } from "react";

export const PageAdminService = lazy(() => import("./Price"));
export const PageAdminServiceList = lazy(() => import("./List"));
export const PageAdminServiceCreate = lazy(() => import("./Add"));
export const PageAdminServiceUpdate = lazy(() => import("./Edit"));

export interface FormServiceValuesProps extends ServiceItemProps { }